import { FaBookOpen } from "react-icons/fa";
import HeroSection from "../../../../../ReusableComponent/HeroSection"

function ExamHeroSection() {
  const stats = [
    { value: "10K+", label: "Questions" },
    { value: "25+", label: "Exam Categories" },
    { value: "100+", label: "Mock Tests" },
    { value: "5K+", label: "Students" },
  ];

  return (
    <HeroSection
      title="Exam Preparation"
      subtitle="Comprehensive preparation for competitive exams and coding contests"
      icon={<FaBookOpen />}
      stats={stats}
    />
  );
}

export default ExamHeroSection;
